var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export class NoPassive {
    constructor(input) {
        this.event = input;
    }
}
export const NoPassiveDiv = (props) => {
    var _a;
    let { onTouchStart } = props, rest = __rest(props, ["onTouchStart"]);
    let finalProps = rest;
    const ref = (_a = props.ref) !== null && _a !== void 0 ? _a : React.useRef(null);
    if (onTouchStart !== undefined && !(onTouchStart instanceof NoPassive)) {
        finalProps = Object.assign(Object.assign({}, rest), { onTouchStart: (e) => onTouchStart(e.nativeEvent) });
    }
    React.useEffect(() => {
        if (typeof (ref) !== 'string' && typeof (ref) !== 'function' && ref.current !== null
            && onTouchStart !== undefined && onTouchStart instanceof NoPassive) {
            const item = ref.current;
            item.addEventListener('touchstart', onTouchStart.event, { passive: false });
            return () => {
                item.removeEventListener('touchstart', onTouchStart.event);
            };
        }
    }, [ref, onTouchStart]);
    return _jsx("div", Object.assign({}, finalProps, { ref: ref }));
};
//# sourceMappingURL=NoPassiveDiv.js.map